export default "__VITE_ASSET__DkK8mFkB__"